export const GENERATED_TEXT_PROMPT_CACHE_KEY = "generated-text-prompt-cache-v1";

export function writeGeneratedTextPromptCacheEntry(arg: {
  textId: number;
  topic: string;
}) {
  if (typeof window === "undefined") {
    return;
  }
  const normalizedTopic = arg.topic.trim();
  if (!normalizedTopic) {
    return;
  }
  let cache: Record<string, string> = {};
  try {
    const existing = window.localStorage.getItem(GENERATED_TEXT_PROMPT_CACHE_KEY);
    if (existing) {
      const parsed = JSON.parse(existing);
      if (parsed && typeof parsed === "object") {
        cache = parsed as Record<string, string>;
      }
    }
  } catch {
    cache = {};
  }

  cache[String(arg.textId)] = normalizedTopic;
  window.localStorage.setItem(GENERATED_TEXT_PROMPT_CACHE_KEY, JSON.stringify(cache));
}
